import React, { useState } from "react";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { SellerLoginApi } from "../../redux/slices/SellerLoginSlice";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

const SellerLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loader, setLoader] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    const data = {
      identifier: identifier,
      password: password,
    };
    setLoader(true);
    dispatch(SellerLoginApi(data)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        toast.success("Login Successful!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
            borderRadius: "8px",
          },
        });
        navigate("/seller/dashboard");
        setLoader(false);
      } else {
        setLoader(false);
        toast.error("User Not Found!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
            borderRadius: "8px",
          },
        });
      }
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br sm:from-pink-50 via-blue-200 to-white py-10 ">
      <div className="bg-white rounded-2xl shadow-lg max-w-md p-8 space-y-8 sm:w-full w-[90%]">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-800">Welcome Back!</h2>
          <h2 className="text-2xl font-bold text-gray-800">Seller</h2>
          <p className="text-gray-600 mt-2">Please sign in to continue</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div className="relative">
            <label className="block text-gray-700 text-sm font-medium">
              Email Or Identifier
            </label>
            <div className="relative mt-2">
              <FaEnvelope className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-500" />
              <input
                type="identifier"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                required
                className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500"
                placeholder="Enter your identifier or userId"
              />
            </div>
          </div>

          <div className="relative">
            <label className="block text-gray-700 text-sm font-medium">
              Password
            </label>
            <div className="relative mt-2">
              <FaLock className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-500" />
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full pl-10 pr-10 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-indigo-500"
                placeholder="Enter your password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500 focus:outline-none"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            <div className="flex justify-end mt-1">
              <button
                type="button"
                onClick={() => navigate("/SellerForgot")}
                className="text-sm text-indigo-500 hover:underline font-medium"
              >
                Forgot Password?
              </button>
            </div>
          </div>

          <div className="flex justify-center">
            <button
              type="submit"
              className="w-full py-3 px-6 bg-indigo-600 text-white font-semibold rounded-lg shadow-md transform transition duration-300 hover:bg-indigo-700 hover:scale-105 focus:outline-none"
            >
              {loader ? "Loading..." : "Login"}
            </button>
          </div>
        </form>

        <div className="text-center">
          <p className="text-sm text-gray-600">
            Don't have an account?{" "}
            <button
              type="button"
              onClick={() => navigate("/SellerRegister")}
              className="text-sm text-indigo-400 hover:underline"
            >
              Sign up
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SellerLogin;
